import { TextInput } from "@circleco/compass/components/TextInput";
import type { FieldError } from "react-hook-form";
import { get, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

const NAME_FIELD_NAME = "name";

export const CheckoutFormNameField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const nameRegistration = register(NAME_FIELD_NAME, { required: true });
  const nameError = get(errors, NAME_FIELD_NAME) as FieldError | undefined;

  return (
    <TextInput
      {...nameRegistration}
      invalid={!!nameError}
      error={
        nameError &&
        t(`paywall_checkout.form.errors.${NAME_FIELD_NAME}_${nameError.type}`)
      }
      label={t("paywall_checkout.form.fields.name")}
      data-testid={`checkout-form-${NAME_FIELD_NAME}-input`}
    />
  );
};
